import { useEffect, useState } from "react";
import { AdminCustomerModel } from "../../../../model/customer/customer";
import BillPageLayout from "../../../admin/bills/component/layout/BillPageLayout";
import { CustomerDetailPage } from "./CustomerDetailPage";
import { CustomerListPage } from "./CustomerListPage";
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
import UtilityPageLayout from "../../component/layout/UtilityPageLayout";
import BroadcastPopup from "./broadcast-notifications/BroadcastPopup";
import UnlinkMeterModal from "./unlink-meter-modal/UnlinkMeterModal";
import { useCan } from "../../../../guards/useCan";
import { UtilityPermissions } from "../../../../model/permissions/permissions";
import { FeatureFlagName } from "../../../../tenant/features/featureFlags";
import { useFeatureFlag } from "../../../../tenant/features/useFeatureFlag";

export const CustomerPage = () => {
	const { updateLayout } = useConfigLayout();
	const { can } = useCan();
	const customersEnabled = useFeatureFlag(FeatureFlagName.ADMIN_CUSTOMERS);
	// Broadcast lives in this page's header; with the page locked there is no list to broadcast to.
	const canBroadcast = can(UtilityPermissions.AddBroadcastNotification) && customersEnabled;
	const [selectedCustomer, setSelectedCustomer] = useState<AdminCustomerModel | null>(null);
	const [isBroadcastOpen, setIsBroadcastOpen] = useState(false);
	const [isUnlinkMeterOpen, setIsUnlinkMeterOpen] = useState(false);

	const handleCustomerSelect = (customer: AdminCustomerModel) => {
		setSelectedCustomer(customer);
	};

	const handleBackToList = () => {
		setSelectedCustomer(null);
	};

	const handleBroadcast = () => {
		setIsBroadcastOpen(true);
	};

	const handleUnlinkMeter = () => {
		setIsUnlinkMeterOpen(true);
	};

	useEffect(() => {
		updateLayout({ showCountrySelector: false });
		return () => {
			updateLayout({ showBroadcastButton: false, broadcastHandler: null, goBackHandler: null });
		};
	}, []);

	useEffect(() => {
		// Broadcast targets the customer list, so hide it on the customer detail view.
		updateLayout({
			showBroadcastButton: !selectedCustomer && canBroadcast,
			broadcastHandler: selectedCustomer || !canBroadcast ? null : handleBroadcast,
			goBackHandler: selectedCustomer ? handleBackToList : null,
		});
	}, [selectedCustomer, canBroadcast]);
	return (
		<UtilityPageLayout title="Customers" feature={FeatureFlagName.ADMIN_CUSTOMERS}>
			{!selectedCustomer ? (
				<CustomerListPage onCustomerSelect={handleCustomerSelect} />
			) : (
				<CustomerDetailPage
					selectedCustomer={selectedCustomer}
					onUnlinkMeter={handleUnlinkMeter}
				/>
			)}
			<BroadcastPopup isOpen={isBroadcastOpen} onClose={() => setIsBroadcastOpen(false)} />
			<UnlinkMeterModal isOpen={isUnlinkMeterOpen} onClose={() => setIsUnlinkMeterOpen(false)} customerId={selectedCustomer?.userId} />
		</UtilityPageLayout>
	);
};
